<ng-container *ngIf="site">

<div class="details-section">
    <div class="section-header">General</div>
    <div class="section-content">
    <div class="section-tab">
        <div class="row"><div class="col1">Name:</div><div class="col"><a routerLink="/site-tree/{{site.id}}">{{ site.name }}</a></div></div>
        <div class="row"><div class="col1">City:</div><div class="col">{{ site.city }}</div></div>
        <div class="row"><div class="col1">Country:</div><div class="col">{{ site.country }}</div></div>
    </div>
    </div>
</div>

<div class="details-section">
    <div class="section-header">Additional</div>
    <div class="section-content">
    <div class="section-tab">
        <div class="row"><div class="col1">Industry Usage:</div><div class="col">{{ site.industryUsageName }}</div></div>
        <div class="row"><div class="col1">Owner ID:</div><div class="col">{{ site.ownerId  }}</div></div>
        <!-- <div class="row"><div class="col1">MIB ID:</div><div class="col">{{ site.id }}</div></div> -->
        <div class="row"><div class="col1">Site ID:</div><div class="col">{{ site.servIsId }}</div></div>
    </div>
    </div>
</div>

<div class="details-section">
    <div class="section-header">Geolocation</div>
    <div class="section-content">
    <div class="section-tab">
        <div class="row"><div class="col1">Latitude:</div><div class="col">{{ site.latitude }}</div></div>
        <div class="row"><div class="col1">Longitude:</div><div class="col">{{ site.longitude  }}</div></div>
    </div>
    </div>
</div>

<div class="details-section">
    <div class="section-header">Tracking</div>
    <div class="section-content">
    <div class="section-tab">
        <div class="row"><div class="col1">Created Time:</div><div class="col">{{ site.createTime | mibDateTime }}</div></div>
        <div class="row"><div class="col1">Updated Time:</div><div class="col">{{ site.updateTime | mibDateTime  }}</div></div>
    </div>
    </div>
</div>


</ng-container>        